import { ShieldCheck } from 'lucide-react'

interface VerificationBadgeProps {
    nip05?: string
    className?: string
}

export function VerificationBadge({ nip05, className = '' }: VerificationBadgeProps) {
    if (!nip05) return null

    return (
        <div
            className={`inline-flex items-center gap-1 px-2 py-0.5 bg-mavi-500/10 border border-mavi-200 dark:border-mavi-800 rounded-md ${className}`}
            title={`Verified: ${nip05}`}
        >
            <ShieldCheck className="w-3 h-3 text-mavi-600 dark:text-mavi-400" />
            <span className="text-[10px] font-poppins font-bold text-mavi-600 dark:text-mavi-400 uppercase tracking-tight">
                Verified
            </span>
        </div>
    )
}
